<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Información Para Patio De Vehículo
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-sm>
                <v-row dense>
                    <v-col cols="12" sm="2">
                        <div class="text-left">
                            <input type="file" style="display:none" ref="patio" accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="loadXLS"/>
                            <v-btn rounded dark color="primary" @click="activeInput">Cargar XLSX
                                <v-icon right dark>attachment</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <div v-show="loadFiles">
                            <v-btn rounded dark color="primary" @click="onGuardar">Subir XLSX
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="2"></v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" dense clearable prepend-inner-icon="search"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table  :search="obSearch.search" :headers="listGeneral.cabecera"
                            :items="listGeneral.detalle" class="elevation-3">

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col xs12 sm12>
                        <v-textarea filled label="Terminos no relacionados" :value="_.join(_.uniq(unrecognized),'\n')" readonly></v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import XLSX from 'xlsx';
    export default {
        name: 'InformacionPatioVehiculoView',
        data:() => ({
            obSearch:{
                search:null
            },
            paginate:{
                offset:0,
                lenght:25
            },
            loadFiles:false,
            criteria:{},
            sheetName: 'BASE PRINCIPAL',
            unrecognized:[],
            listGeneral:{
                cabecera: [],
                detalle:[]
            }
        }),
        created(){
            axios.post(`${BASE_URI}administrador/informacion-patio-vehiculo/cargaGeneral`,{})
                 .then((r) => {
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'criteria',r.data.data.diccionario);
                        return this.onListar('L');
                 })
                 .catch((e) =>{
                     mensajesAlerta(e,'E');
                 })
        },
         methods:{
            onListar(event){
                if(!_.isUndefined(event)){
                    axios.post(`${BASE_URI}administrador/informacion-patio-vehiculo/listarMasivo`,this.paginate)
                        .then((r) => {
                            if(_.toNumber(_.get(r,['data','data'],0)) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                this.listGeneral.detalle = r.data.data.listVehiculo;
                                this.paginate.offset+= r.data.data.lenght + 1;
                                this.paginate.lenght+= r.data.data.lenght;
                        })
                        .catch((e) =>{
                            mensajesAlerta(e,'E');
                        });
                }
            },
            onGuardar(){
                axios.post(`${BASE_URI}administrador/informacion-patio-vehiculo/insertar`,{lista:this.listGeneral.detalle,unrecognized:this.unrecognized})
                     .then((response) => {
                         if(_.size(_.get(response,['data','data','filasAfectadas'])) == 0) throw mensajeEstandar.errorPeticion;
                            mensajeAlertaTiempo('Se procesaron los registros con exito.','S');
                            return this.onListar('L');
                     })
                     .catch((e) =>{
                        mensajesAlerta(e,'E');
                     });
            },
            loadXLS(e) {
                try {
                    var cab = [
                                "CATEGORIA1", "CATEGORIA2", "CATEGORIA3", "MARCA", "MODELO", 
                                "SUB MODELO", "DESCRIPCION", "P.V.P.", "P. TOMA", 
                                "AÑO", "CILINDRADA", "COMBUSTIBLE", "TIPO", "PASAJEROS"
                              ];

                    if (_.size(e.target.files) == 0) throw ("No hay archivos seleccionados");
                        this.$root.loading.mostrar = true;
                        this.readXLS(e.target.files[0], this.sheetName,cab)
                                    .then((r) => {
                                            this.loadFiles = true;
                                            this.makeFromXLS(r);
                                        }).catch((err) => {
                                            this.$root.loading.mostrar = false;
                                            // readXLS rechaza con un texto (no un Error), por eso no siempre hay err.message
                                            mensajesAlerta(_.get(err,'message',err),'I');
                                        }).finally(() => {
                                            this.$root.loading.mostrar = false;
                                            console.log("end");
                                        })
                        
                } catch (err) {
                    mensajesAlerta(_.get(err,'message',err),'I');
                }
            },
            activeInput(){
                this.$refs.patio.click()
            },
            onGuardar(){
                axios.post(`${BASE_URI}administrador/informacion-patio-vehiculo/insertar`,this.listGeneral.detalle)
                     .then((response) => {
                         if(_.size(_.get(response,['data','data','filasAfectadas'])) == 0) throw mensajeEstandar.errorPeticion;
                            mensajeAlertaTiempo('Se procesaron los registros con exito.','S');
                            return this.onListar('L');
                     })
                     .catch((e) =>{
                        mensajesAlerta(e,'I')
                     });
            },
            concatDump(...iterables){
                const set = new Set();
                for (let iterable of iterables) {
                    for (let item of iterable) {
                    set.add(item);
                    }
                }
                return set;
            },
            processDescription(criteria={},descripcion="",props={},delThis=[]){
                props.input=descripcion;
                descripcion=`  ${_.toUpper(_.deburr(descripcion))}  `;
        
                var dump = new Set();

                _.forEach(delThis,(word)=>{
                    var w=RegExp(word, 'gi');
                    descripcion=descripcion.replace(w,' ');
                });

                var s = descripcion;
                _.forEach(criteria, (vv, prop) => {

                    if (_.isString(vv)) {

                        var e = RegExp(` ${vv} `, 'i');
                        var o = s.match(e) || [];
                        if (o.length > 0) _.set(props, prop, _.trim(o[1] || o[0]));
                        descripcion=descripcion.replace(e,' ');
                    } else if (_.isArray(vv)) {

                        var hj = [];
                        _.forEach(vv, (x, t) => {
                            var e = RegExp(` ${x} `, 'i');
                            var o = s.match(e) || [];
                            if (o.length > 0) hj.push(_.trim(o[1] || o[0]));
                            descripcion=descripcion.replace(e,' ');
                        });
                        if (hj.length > 0) _.set(props, prop, _.join(hj, ', '));

                    } else if (_.isObject(vv)) {

                        if (_.has(vv, 'pattern')) {
                            var e= RegExp(` ${vv.pattern} `, 'gi');
                            var o =e.test(s);
                            if (o) _.set(props, prop, o);
                            descripcion=descripcion.replace(e,' ');
                        } else {
                            _.forEach(vv, (x, t) => {
                                var jw=_.castArray(x);
                                var ety=0;
                                _.forEach(jw, (xd, td) => {
                                    var e=RegExp(` ${xd} `, 'i');
                                    if (e.test(s))ety++;
                                    descripcion=descripcion.replace(e,' ');
                                });
                                if(ety>0)_.set(props, prop, t);
                            });
                        }

                    }
                });

                props.output=_.trim(descripcion).replace(/\s{2,}/gi," ");
                if(!_.isEmpty(props.output))dump.add(props.output);

                return {result:props,dump};
            },
            makeFromXLS(data) {
                var dump = new Set();

                var result=_.map(data, (item) => {
                    var delThis=[];

                    var props = {
                        marca:_.trim(_.deburr(item.marca)),
                        modelo:((modelo,subModelo)=>{
                            modelo=_.toUpper(_.trim(_.deburr(modelo)));
                            subModelo=_.toUpper(_.trim(_.deburr(subModelo)));
                            delThis.push(modelo,subModelo);
                            return `${modelo} ${subModelo}`;
                        })(item.modelo,item.subModelo),
                        ano:item.ano,
                        valor:item.pVP,
                        cilindraje:((cilindrada)=>{
                            cilindrada=_.toUpper(cilindrada);
                            delThis.push(cilindrada);
                            return parseFloat(String(cilindrada).replace(/[A-Z]/ig,""))*1000;
                        })(item.cilindrada)
                    };
                    
                    var out=this.processDescription(this.criteria,item.descripcion,props,delThis);

                    dump=this.concatDump(dump,out.dump);

                    return out.result;
                    
                });
                var l = dump.values();
                this.unrecognized = Array.from(l);
                this.listGeneral.detalle = result;
                console.log(result,this.unrecognized);
            


            },
            sendServer(){

                var data={
                    a:25,
                    b:50,
                    c:75
                };

                axios({
                    url:'/xmlFromServer',
                }).then((r)=>{
                    return r.data;
                }).then((xml)=>{
                    return axios({
                        url:"toServer",
                        method:'post',
                        data:this.makeFromXML(data,xml)
                    });
                }).then((r)=>{
                    console.log(r.data)
                });
            },
            makeFromXML(data,xml) {
                var delThis=[];
                var props = {
                    marca:_.trim(xml.marcaDesc),
                    ano:parseInt(xml.anio),
                    cilindraje:((cilindrada)=>{
                        var cilindradaOld=cilindrada;
                        var cilindrada=(parseInt(cilindrada)*0.001).toFixed(1);
                        delThis.push(`${cilindrada}L`,`${cilindrada} L`,cilindrada);
                        return parseInt(cilindradaOld);
                    })(xml.cilindraje)
                };
                var out=this.processDescription(this.criteria,xml.modeloDesc,props,delThis);
                return _.merge(data,out.result);
            }
        }
    }
</script>

<style>

</style>